import React, { Component } from 'react'
import { Form, Button, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faLockOpen, faCamera } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { postData } from '../../utils/index';
import { API_BASE_URL, WORKSPACE_CREATE } from '../../config/index';

import './Left.css';

class AddWorkspace extends Component {

    constructor(props) {
        super(props);
        this.state = {
            workspace_name: "",
            subscription_id: "FREE",
            user_id: "",
            workspace_pic: "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",
            workspace_pic_name: `${Date.now()}`,
            workspace_pic_mime: "image/svg+xml",

            create_room: false,

            room_name: "",
            room_description: "",
            room_pic: "",
            room_type: false,
            video_server_location: 'eu-central-1'
        }
    }

    componentDidMount() {
        const { currentUser } = this.props;
        this._handleStateChange("user_id", currentUser.uid);
    }


    _handleStateChange = (attr, val) => this.setState({ [attr]: val })


    _handleCreateWorkspace = () => {
        const {
            workspace_name,
            subscription_id,
            user_id,
            create_room,
            room_name,
            room_description,
            room_pic,
            room_type,
            video_server_location,
            workspace_pic,
            workspace_pic_name,
            workspace_pic_mime
        } = this.state;

        const workspaceData = {
            workspace_name,
            subscription_id,
            user_id,
            create_room,
            room_name,
            room_description,
            room_pic,
            room_type: room_type ? "1" : "0",
            video_server_location,
            workspace_pic,
            workspace_pic_name,
            workspace_pic_mime
        }

        console.log("workspaceData", workspaceData)

        postData(`${API_BASE_URL}${WORKSPACE_CREATE}`, workspaceData)
            .then(response => {
                console.log(response)
                const { message, status } = response;
                if (status === 400) {
                    alert(message)
                }
            })
            .catch(error => console.error(error))
    }

    _handleChangeFile = event => {
        const file = event.target.files[0];
        const reader = new FileReader();

        if (file) {
            reader.readAsDataURL(file);
            reader.addEventListener("load", () => {
                this.setState({
                    workspace_pic: reader.result.split("base64,")[1],
                    workspace_pic_mime: file.type,
                    workspace_pic_name: file.name
                });
            });
        }
    }


    render() {
        const {
            workspace_name,
            subscription_id,
            user_id,
            create_room,
            room_name,
            room_description,
            room_pic,
            room_type,
            video_server_location,
            workspace_pic,
            workspace_pic_name,
            workspace_pic_mime
        } = this.state;

        const { currentUser } = this.props;

        return (
            <div className="p-3">
                <h4 className="text-theme">Add Workspace</h4>

                <Form className="mt-2">
                    <Form.Group>
                        <Form.Label>Workspace name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter workspace name"
                            value={workspace_name}
                            onChange={e => this._handleStateChange("workspace_name", e.target.value)} />
                        <Form.Text className="text-muted">It can be name of your organisation e.g. iarani Inc.</Form.Text>
                    </Form.Group>

                    <div className="my-5 mx-auto" id="add-avatar">
                        <label for="avatar">
                            <Image
                                id="avatar-image"
                                width="150"
                                height="150"
                                roundedCircle
                                src={workspace_pic
                                    ? `data:${workspace_pic_mime};base64,${workspace_pic}`
                                    : "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/avatars%2Fusers%2Fgroup-icon.svg?alt=media&token=fb8447a2-3564-4fe7-bf57-c7452f9c5baa"}
                                style={{ background: '#AEAEAE' }}
                            />
                        </label>
                        <input type="file" id="avatar" accept="image/png, image/jpeg" onChange={this._handleChangeFile} />

                        <label for="avatar" id="overlay">
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <FontAwesomeIcon icon={faCamera} className="text-white" />
                                <small className="text-white text-center px-2">ADD WORKSPACE ICON</small>
                            </div>
                        </label>
                    </div>

                    <Form.Group>
                        {/* <Form.Label>Subscription</Form.Label> */}
                        <Form.Control
                            type="hidden"
                            placeholder="Enter subscription"
                            value={subscription_id}
                            onChange={e => this._handleStateChange("subscription_id", e.target.value)} />
                    </Form.Group>

                    <Form.Group>
                        {/* <Form.Label>User ID</Form.Label> */}
                        <Form.Control
                            type="hidden"
                            placeholder="Enter user id"
                            value={user_id}
                            onChange={e => this._handleStateChange("user_id", e.target.value)} />
                    </Form.Group>

                    <Form.Group>
                        <Form.Check
                            type="checkbox"
                            label="Create a general room"
                            value={create_room}
                            onChange={e => this._handleStateChange("create_room", !create_room)} />
                    </Form.Group>

                    {create_room && <>
                        <Form.Group>
                            <Form.Label>Room name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter room name"
                                value={room_name}
                                onChange={e => this._handleStateChange("room_name", e.target.value)} />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Room description</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter room description"
                                value={room_description}
                                onChange={e => this._handleStateChange("room_description", e.target.value)} />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Room picture</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter room picture"
                                value={room_pic}
                                onChange={e => this._handleStateChange("room_pic", e.target.value)} />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Video server location</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter video server location"
                                value={video_server_location}
                                onChange={e => this._handleStateChange("video_server_location", e.target.value)} />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Want to keep this room private?</Form.Label>
                            <div className="d-flex align-items-center">
                                <Form.Check
                                    type="switch"
                                    id="room_type"
                                    className="flex-grow-1"
                                    label={room_type ? "Private" : "Public"}
                                    value={room_type}
                                    onChange={e => this._handleStateChange("room_type", !room_type)}
                                />
                                <FontAwesomeIcon
                                    icon={room_type ? faLock : faLockOpen}
                                    className={room_type ? "text-success" : "text-theme"}
                                    size="sm" />
                            </div>
                        </Form.Group>
                    </>}

                    <Button
                        variant="primary"
                        onClick={this._handleCreateWorkspace}>Submit</Button>
                </Form>
            </div>
        )
    }
}

const mapStatesToProps = state => ({
    currentUser: state.user.currentUser
})

export default connect(mapStatesToProps)(AddWorkspace);